<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="common_title">
        历史委托

        <TopPartner @refreshTopPartner="handleSearch"></TopPartner>
      </div>

      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">合约名称</div> -->
            <div class="ipt">
              <el-select
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="symbolId"
                placeholder="请选择"
                @change="changeName"
              >
                <el-option value="" label="全部合约名称"></el-option>

                <el-option
                  v-for="item in symbolList"
                  :key="item.id"
                  :label="item.symbol"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                class="userUid_ipt"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>

          <!-- <div class="item">
            <div class="txt">合伙人UID</div>
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="channelUserId">
              </el-input>
            </div>
          </div> -->
          <div class="item">
            <!-- <div class="txt">委托订单ID</div> -->
            <div class="ipt">
              <el-input placeholder="委托订单ID" clearable v-model="orderId">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input placeholder="仓位ID" clearable v-model="positionId">
              </el-input>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="small" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <!-- <div class="txt">注册日期</div> -->
            <div class="ipt">
              <el-date-picker
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <!-- <div class="item">
            <el-button size="small" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <div class="item-sle">
              <div class="tit">特殊账号</div>
              <el-select size="small" v-model="type" placeholder="特殊账号">
                <el-option
                  v-for="item in [
                    { id: 1, value: '隐藏' },
                    { id: 2, value: '显示' },
                  ]"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
          <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import userUid from "@/assets/input/userUid.png";
import invite from "@/assets/input/invite.png";
import channel from "@/assets/input/channel.png";
import TopPartner from "../topPartner";
import { tenantInfo } from "@/common/publicApi";
export default {
  name: "historyDelegation",
  components: {
    UserList,
    TopPartner,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      type: 1,
      value2: "",
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      symbolId: "",
      orderId: "",
      value1: "",
      positionId: "",
      // value1: [
      // moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     "-" +
      //     (new Date().getMonth() + 1) +
      //     "-" +
      //     new Date().getDate(),
      // ],
      // value1: [
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     (new Date().getDate() - 7),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      // value1: '',
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tenantList: [],
      tenantId: "",
    };
  },
  computed: {
    ...mapState("historyDelegation", [
      "queryType",
      "queryTypeList",
      "pagination",
      "symbolList",
    ]),
    ...mapState(["userInfo"]),
    ...mapState("topPartner", ["topPartner"]),
  },
  methods: {
    ...mapActions("historyDelegation", [
      "list",
      "getSymbolList",
      "exportExcel",
    ]),
    ...mapMutations("historyDelegation", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        channelId: this.topPartner,
        symbolId: this.symbolId,
        orderId: this.orderId,
        positionId: this.positionId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...this.pagination,
        ...data,
      });
    },
    getExcel() {
      this.exportExcel({
        channelId: this.topPartner,
        symbolId: this.symbolId,
        orderId: this.orderId,
        positionId: this.positionId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址
        console.log("link-href", link.href);
        link.download = "历史委托";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
      });
    },
    changeName(e) {
      this.handleSearch();
    },
    changeTime(e) {
      this.list({
        channelId: this.topPartner,
        symbolId: this.symbolId,
        orderId: this.orderId,
        positionId: this.positionId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() - 1),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          (new Date().getDate() - 1),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        channelId: this.topPartner,
        symbolId: this.symbolId,
        orderId: this.orderId,
        positionId: this.positionId,
        userId: this.userId,
        type: this.type,
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.getSymbolList();
    this.list({
      channelId: this.topPartner,
      symbolId: this.symbolId,
      orderId: this.orderId,
      positionId: this.positionId,
      userId: this.userId,
      type: this.type,
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      tenantId: this.tenantId,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
